module.exports = __webpack_public_path__ + "img/atimes.d4c54372.png";